import { useCallback } from 'react';
import { Splash } from './components/Splash';
import { useGameStore } from './hooks/useGameStore';
import { useLoadResources } from './hooks/useLoadResources';
import { EnemyView } from './modules/EnemyView';
import { GameOverView } from './modules/GameOverView';
import { GameView } from './modules/GameView';
import { HighscoreView } from './modules/HighscoreView';
import { PlayerView } from './modules/PlayerView';

function App() {
  const resourcesLoaded = useLoadResources();
  const view = useGameStore(useCallback((state) => state.view, []));

  if (!resourcesLoaded) {
    return null;
  }

  return (
    <div className="w-full min-h-full">
      {view === 'EnemyView' && <EnemyView />}
      {view === 'PlayerView' && <PlayerView />}
      {view === 'GameView' && <GameView />}
      {view === 'GameOver' && <GameOverView />}
      {view === 'HighscoreView' && <HighscoreView />}
      <Splash />
    </div>
  );
}

export default App;
